export const SALES_SUB_APPS = {
  activities: 'activities',
  callOutcomes: 'callOutcomes',
  taskOutcomes: 'taskOutcomes',
  conversations: 'conversations',
  lossReasons: 'lossReasons',
  salesBySource: 'salesBySource',
  dealJourney: 'dealJourney',
  dealsCreatedByRep: 'dealsCreatedByRep',
  dealsWon: 'dealsWon',
  weightedPipelineForecast: 'weightedPipelineForecast',
  averageSalesPrice: 'averageSalesPrice',
  timeInDealStage: 'timeInDealStage',
  activityStream: 'activityStream',
  dealVelocity: 'dealVelocity',
  leadResponseTime: 'leadResponseTime',
  waterfall: 'waterfall',
  changeHistoryDealList: 'changeHistoryDealList',
  dealPushAnalysis: 'dealPushAnalysis',
  pipelineSnapshots: 'pipelineSnapshots',
  quotaAttainment: 'quotaAttainment',
  manualForecast: 'manualForecast',
  manualForecastTotal: 'manualForecastTotal',
  meetingOutcomes: 'meetingOutcomes',
  prospectEngagement: 'prospectEngagement',
  leadFunnel: 'leadFunnel',
  salesVelocity: 'salesVelocity',
  lineItemRevenue: 'lineItemRevenue',
  teamActivity: 'teamActivity',
  calls: 'calls',
  tasks: 'tasks',
  meetings: 'meetings',
  sequences: 'sequences',
  leads: 'leads',
  emailRates: 'emailRates'
};
export const SERVICE_SUB_APPS = {
  ticketTimeInPipeline: 'ticketTimeInPipeline',
  supportVolume: 'supportVolume',
  resolutionTime: 'resolutionTime',
  ticketTimeToClose: 'ticketTimeToClose',
  ticketTimeToRespond: 'ticketTimeToRespond',
  queueTime: 'queueTime',
  postSupportCSAT: 'postSupportCSAT',
  customerEffortScore: 'customerEffortScore',
  customerReplyTime: 'customerReplyTime',
  customerWaitTime: 'customerWaitTime',
  ownerReplyCount: 'ownerReplyCount',
  ownerReplyTime: 'ownerReplyTime',
  ticketReplyCount: 'ticketReplyCount',
  timeOfDay: 'timeOfDay',
  workingHoursAvailability: 'workingHoursAvailability',
  maxAvailableRep: 'maxAvailableRep',
  repAvailability: 'repAvailability',
  ticketEnteredNew: 'ticketEnteredNew',
  ticketEnteredWaiting: 'ticketEnteredWaiting',
  knowledgeBaseToTickets: 'knowledgeBaseToTickets',
  chatbotAndCustomerAgentHandoffs: 'chatbotAndCustomerAgentHandoffs',
  chatbotHandoffs: 'chatbotHandoffs',
  ticketsToDeals: 'ticketsToDeals'
};
export const SUBSCRIPTION_SUB_APPS = {
  newMonthlyRecurringRevenue: 'newMonthlyRecurringRevenue',
  newAnnualRecurringRevenue: 'newAnnualRecurringRevenue',
  churnMonthlyRecurringRevenue: 'churnMonthlyRecurringRevenue',
  churnAnnualRecurringRevenue: 'churnAnnualRecurringRevenue',
  churnSubscriptions: 'churnSubscriptions',
  newSubscriptions: 'newSubscriptions'
};
export const COMMERCE_SUB_APPS = {
  agingSummary: 'agingSummary',
  balanceDue: 'balanceDue',
  expectedVsActualRevenue: 'expectedVsActualRevenue',
  invoiceStatus: 'invoiceStatus',
  commerceChurnSubscriptions: 'commerceChurnSubscriptions',
  commerceChurnSubscriptionsCount: 'commerceChurnSubscriptionsCount',
  commerceNewSubscriptions: 'commerceNewSubscriptions',
  commerceNewSubscriptionsCount: 'commerceNewSubscriptionsCount',
  grossPaymentRevenue: 'grossPaymentRevenue',
  totalPaymentVolume: 'totalPaymentVolume',
  paymentCustomers: 'paymentCustomers'
};
export const MARKETING_SUB_APPS = {
  attribution: 'attribution',
  ads: 'ads',
  leadCapture: 'leadCapture',
  marketingEmails: 'marketingEmails',
  sources: 'sources',
  pages: 'pages',
  sms: 'sms',
  geolocation: 'geolocation',
  utmParameters: 'utmParameters',
  browsers: 'browsers',
  deviceTypes: 'deviceTypes',
  topicClusters: 'topicClusters',
  marketingRevenueImpact: 'marketingRevenueImpact',
  adImpact: 'adImpact',
  blogImpact: 'blogImpact',
  formImpact: 'formImpact',
  landingPageImpact: 'landingPageImpact',
  marketingSources: 'marketingSources',
  contactInsights: 'contactInsights',
  customerJourneyAnalytics: 'customerJourneyAnalytics',
  cta: 'cta',
  social: 'social'
};
export const SUB_APPS = Object.assign({}, SALES_SUB_APPS, SERVICE_SUB_APPS, SUBSCRIPTION_SUB_APPS, COMMERCE_SUB_APPS, MARKETING_SUB_APPS);